import { useHandler } from '../../useHandlerMutation';

export const useCreateContact = () =>
  useHandler((api) => api.contact().createContact, {
    invalidates: () => [['CONTACTS']],
  });
